import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bc52787a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=bc52787a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc52787a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShareButtons: require('/home/circleci/repo/components/ShareButtons.vue').default,VButton: require('/home/circleci/repo/components/VButton.vue').default,CompanyFounder: require('/home/circleci/repo/components/company/CompanyFounder.vue').default,CompanyInnovationCurve: require('/home/circleci/repo/components/company/CompanyInnovationCurve.vue').default,Loader: require('/home/circleci/repo/components/Loader.vue').default,CompanyPageLanding: require('/home/circleci/repo/components/CompanyPageLanding.vue').default,FormEditRating: require('/home/circleci/repo/components/form/FormEditRating.vue').default})
